
















import { Component, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class ShowPassword extends Vue {
    public showPassword: boolean = false;

    @Watch('showPassword')
    public onShowPasswordChange(val: boolean) {
        this.$emit('showPasswordChanged', val);
    }
}
